<template>
  <div class="row no-gutters">
    <div class="col-12">
      <Errors :errors="errors" />
    </div>

    <div
      v-if="fieldsToShow.includes('full_name')"
      class="col-12"
    >
      <div class="form-group ml-1 mr-1">
        <label>{{ $t('lang.forms.name') }} *</label>
        <input
          v-model="user.full_name"
          type="text"
          class="form-control"
          required
          @change="updateFullName"
        >
      </div>
    </div>

    <div
      v-if="fieldsToShow.includes('nationality')"
      class="col-12 pl-1 pr-1"
    >
      <UserCountry
        :country="user.country"
        @countrySelected="updateUserCountry"
      />
    </div>

    <div
      v-if="fieldsToShow.includes('doc_type')"
      class="col-12 col-md-6"
    >
      <div class="form-group ml-1 mr-1">
        <label>{{ $t('lang.forms.doc_type') }} *</label>
        <select
          v-model="user.doc_type"
          class="form-control"
          required
          @change="$emit('changes', {'doc_type': user.doc_type})"
        >
          <option value="dni_arg">
            {{ $t('lang.forms.doc_types.dni') }}
          </option>
          <option value="passport">
            {{ $t('lang.forms.doc_types.passport') }}
          </option>
          <option value="cpf">
            {{ $t('lang.forms.doc_types.cpf') }}
          </option>
          <option value="rfc">
            {{ $t('lang.forms.doc_types.rfc') }}
          </option>
          <option value="other">
            {{ $t('lang.forms.doc_types.other') }}
          </option>
        </select>
      </div>
    </div>
    <div
      v-if="fieldsToShow.includes('doc_number')"
      class="col-12 col-md-6"
    >
      <div class="form-group ml-1 mr-1">
        <label>{{ $t('lang.forms.doc_number') }} *
        </label>
        <input
          v-model="user.doc_number"
          type="text"
          class="form-control"
          required
          @change="$emit('changes', {'doc_number': user.doc_number})"
        >
      </div>
    </div>

    <div
      v-if="fieldsToShow.includes('birthdate')"
      class="col-12 col-md-6"
    >
      <div class="form-group ml-1 mr-1">
        <label>{{ $t('lang.forms.birthdate') }}</label>
        <input
          v-model="user.birthdate"
          type="date"
          class="form-control"
          @change="$emit('changes', {'birthdate': user.birthdate})"
        >
      </div>
    </div>
    <div
      v-if="fieldsToShow.includes('gender')"
      class="col-12 col-md-6"
    >
      <div class="form-group ml-1 mr-1">
        <label>{{ $t('lang.forms.gender.title') }}</label>
        <select
          v-model="user.gender"
          class="form-control"
          required
          @change="$emit('changes', {'gender': user.gender})"
        >
          <option value="F">
            {{ $t('lang.forms.gender.f') }}
          </option>
          <option value="M">
            {{ $t('lang.forms.gender.m') }}
          </option>
          <option value="O">
            {{ $t('lang.forms.gender.o') }}
          </option>
        </select>
      </div>
    </div>

    <div
      v-if="fieldsToShow.includes('telephone')"
      class="col-12 col-md-6"
    >
      <div class="form-group ml-1 mr-1">
        <label>{{ $t('lang.forms.phone') }}</label>

        <TelephoneInput
          :user-phone-number="userPhoneNumber"
          :default-country="user.country"
          @userPhoneUpdated="userPhoneUpdated"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UserCountry from '@/components/User/UserCountry';
import Errors from '@/components/Alerts/Errors';
import TelephoneInput from '@/components/User/TelephoneInput.vue';

export default {
  name: 'UserData',
  components: {
    TelephoneInput,
    Errors,
    UserCountry,
  },
  props: {
    userData: {
      type: Object,
      required: false,
    },
    fieldsToShow: {
      type: Array,
      default() {
        return ['full_name', 'nationality', 'telephone', 'doc_type', 'doc_number', 'birthdate', 'gender'];
      },
      required: false,
    },
  },

  data() {
    return {
      user: this.userData,
      errors: {},
    };
  },

  computed: {
    userPhoneNumber() {
      if (this.user.telephone !== '' && this.user.telephone != null) {
        return `+${this.user.telephone_cc + this.user.telephone}`;
      }
      return null;
    },
    fullNameIsValid() {
      // 2 letters + space + 2 letters
      const r = /(\S\S+\s+\S\S)+/i;

      if (r.test(this.user.full_name)) {
        return true;
      }

      return false;
    },
  },

  created() {
    if (this.fieldsToShow.includes('doc_type') && this.user.doc_type === null) {
      this.defaultDocType();
    }
    if (this.fieldsToShow.includes('full_name')) {
      this.updateFullName();
    }
  },

  methods: {
    defaultDocType() { // set default doc type
      const countryDocTypes = {
        MX: 'rfc',
        BR: 'cpf',
        AR: 'dni_arg',
      };
      this.user.doc_type = countryDocTypes[this.user.country] || 'other';
      this.$emit('changes', { doc_type: this.user.doc_type });
    },

    updateUserCountry(country) {
      this.$emit('changes', { country });
      this.updateFullName(); // to validate name again.
      this.defaultDocType();
    },

    updateFullName() {
      this.$emit('fullNameError', true);
      if (this.fullNameIsValid) {
        this.errors = {};
        this.$emit('fullNameError', false);
        this.$emit('changes', { full_name: this.user.full_name });
      } else {
        this.errors = { full_name_error: [this.$t('lang.forms.full_name_error')] };
      }
    },

    userPhoneUpdated(value) {
      this.$emit('changes', value);
    },
  },
};
</script>

<style scoped>
.booking select {
  display: block;
  height: 45px;
}
.booking input {
  font-weight: 500;
}
</style>
